/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagKey } from './tagKey';


export interface TagCreateRequest { 
    tagKey: TagKey;
    /**
     * The tag's name in plain text for human readability
     */
    displayName: string;
    /**
     * An optional tag's search score multiplier. Search score multiplier is numeric and can be a decimal
     */
    searchScoreMultiplier?: number;
    /**
     * An optional description
     */
    description?: string;
    parentTagKey?: TagKey;
}
